var CNotificationList = CBaseModel.extend({
    idAttribute: 'notificationid',

    defaults: {
        notificationid: null,
        notificationname: '',
        notificationtype: '',
        recipients: [],
        states: {
            /*
             'SOME_KEY': {
             email_user: false,
             sms_user: false,
             notify_list: false
             }
             */
        },
        defaultlist: false// Whether the list is the user's default list
    },

    initialize: function(objAttributes)
    {
        this.urls = {
            create: '/ajax/notification_list/edit_list.php',
            update: '/ajax/notification_list/edit_list.php',
            delete: '/ajax/notification_list/delete_list.php'
        };
    },

    validate: function(attributes, options)
    {
        var self = this;

        if (!attributes.notificationtype)
        {
            return 'Notification list must have a template selected';
        }

        var re = /^[a-z0-9-_\såÅøØæÆ]+$/i;
        if (!re.test(attributes.notificationname))
        {
            return 'Notification list name can only have letters, numbers, whitespaces and the following characters: underscore(_) and dash(-)';
        }

        if (!attributes.recipients && self.statesIncludeRecipientsPreferences(attributes.states))
        {
            return 'Notification list needs to have at least one recipient assigned when setting preferences for the recipient list';
        }

        var bValidRecipients = _.every(attributes.recipients, function(strRecipient) {
            return (self.isEmail(strRecipient) || self.isPhoneNumber(strRecipient));
        });

        if (!bValidRecipients)
        {
            return 'Recipients need to be valid emails or phone numbers';
        }
    },

    isEmail: function(strEmail) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(strEmail);
    },

    isPhoneNumber: function(strMobile) {
        var re = /^[0-9]+$/i;
        return re.test(strMobile);
    },

    statesIncludeRecipientsPreferences: function(states)
    {
        return _.findWhere(_.values(states), {notify_list: true});
    }
});